module.exports = __webpack_public_path__ + "static/img/img_program_d.ef1fc7d4.png";